export class Parsed {
  _: string[] = [];
  Changed?: string[] = [];
  Added?: string[] = [];
  Removed?: string[] = [];
  Deprecated?: string[] = [];
  Fixed?: string[] = [];
  Security?: string[] = [];
}
